import { EditableFieldProps } from '../core-field/editable-field-json-props'

export const UI2_SWITCH_FIELD_DEFAULT_PROPS: Partial<UI2SwitchFieldProps> = {
  /** @platform web — mobile switch always uses a horizontal label+control layout. */
  isHorizontalLayout: true,
}

export interface UI2SwitchFieldProps extends EditableFieldProps<boolean> {}
